<template>
  <div class="my-details" v-if="username">
    <div class="my-details__banner">
      <div class="my-details__banner--welcome-text">Welcome back {{ username }},</div>
      <div class="my-details__banner--strap-line-text">Keep your personal details up to date</div>
    </div>
    <apio-snackbar :text="snackBarText" :status="snackBarStatus" :snackbar="snackbar" @close="snackbar = false" />
    <v-card v-if="mode === 'details'" class="my-details__main">
      <v-row>
        <v-col class="my-details__main-col" cols="12" sm="12" md="6" lg="6">
          <div class="small-extra-bold">Full name</div>
              <v-text-field
                type="full name"
                name="full name"
                :error="true"
                dense
                outlined
                required
                :value="username"
                placeholder="Type here..."
                :hide-details="true"
              >
              </v-text-field>
              <div class="mt-6 small-extra-bold">Email address</div>
              <v-text-field
                type="email"
                :error="true"
                name="email"
                dense
                outlined
                required
                :value="user_email"
                placeholder="Type here..."
                :hide-details="true"
              >
              </v-text-field>
               <div class="mt-6 small-extra-bold">Password</div>
              <v-text-field
                :error="true"
                disabled
                dense
                outlined
                required
                placeholder="**********"
                :hide-details="true"
              >
              </v-text-field>
        </v-col>
        <v-col class="my-details__main-col" cols="12" sm="12" md="6" lg="6">
          <span @click="updateMyPassword" class="my-details__update-password-link link-default">Update my password<apio-icon class="ml-2" name="chevron-right" size="16" lightModeColour="cyan" darkModeColour="cyan" /></span>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-else class="my-details__main">
      <v-row>
         <v-col class="my-details__main-col" cols="12" sm="12" md="6" lg="6">
              <validation-observer
                tag="form"
                ref="resetpassword"
                class="reset-password--form"
                @submit.prevent="onSubmit()"
              >

                <validation-provider
                  v-slot="{ }"
                  rules="required|min:8"
                  name="new_pass"
                  tag="div"
                >
                  <div class="small-extra-bold">New Password</div>
                  <v-text-field
                    persistent-hint
                    :error="true"
                    dense
                    outlined
                    required
                    v-model="new_pass"
                    placeholder="New password..."
                    :hide-details="true"
                    :type="showNewPassword ? 'text' : 'password'"
                    @click:append="showNewPassword = !showNewPassword"
                  >
                    <template slot="append">
                      <apio-icon style="cursor: pointer;" @click.native="showPassword = !showPassword" v-if="showPassword" name="ui-eye-open" />
                      <apio-icon style="cursor: pointer;" @click.native="showPassword = !showPassword" v-else name="ui-eye-closed" />
                    </template>
                  </v-text-field>
                </validation-provider>

                <div class="mt-6 small-extra-bold">Confirm Password</div>
                <v-text-field
                  persistent-hint
                  :error="true"
                  dense
                  outlined
                  required
                  v-model="new_pass_confirm"
                  placeholder="Confirm password..."
                  :hide-details="true"
                  :type="showConfirmPassword ? 'text' : 'password'"
                >
                  <template slot="append">
                    <apio-icon style="cursor: pointer;" @click.native="showConfirmPassword = !showConfirmPassword" v-if="showConfirmPassword" name="ui-eye-open" />
                    <apio-icon style="cursor: pointer;" @click.native="showConfirmPassword = !showConfirmPassword" v-else name="ui-eye-closed" />
                  </template>
                </v-text-field>

                <password
                  v-model="new_pass"
                  class="my-details__password-meter"
                  @score="score"
                  :strength-meter-only="true"
                />

                <div class="tiny my-details__weak-strong"><div>Weak</div><div>Strong</div></div>

                <p class="tiny mb-8">
                  Minimum 8 characters. Must include lowercase, upper case and a
                  number.
                </p>

                <p class="text-danger" v-if="message">{{ message }}</p>
              </validation-observer>

        </v-col>
        <v-col class="my-details__main-col" cols="12" sm="12" md="6" lg="6" />
      </v-row>
    </v-card>
    <div class="my-details__actions">
      <apio-button button-type="secondary" @click.native="cancel"
        >Cancel</apio-button
      >
      <apio-button v-if="mode === 'details'" @click.native="save"
        >Confirm changes</apio-button
      >
      <apio-button
        v-if="mode === 'changepw'"
        :disabled="
          pwscore < 3 ||
          new_pass == '' ||
          new_pass_confirm == '' ||
          new_pass != new_pass_confirm
        "
        variant="success"
        block
        @click.native="resetPassword()"
        >Confirm</apio-button
      >
    </div>
  </div>
</template>

<script>
import request from '@/API/';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      full_name: '',
      email: '',
      mode: 'details', // or changepw,
      new_pass: "",
      new_pass_confirm: "",
      message: "",
      errpwd: false,
      done: false,
      pwscore: 0,
      showNewPassword: false,
      showConfirmPassword: false,
      snackbar: false,
      snackBarText: '',
      snackBarStatus: null,
    }
  },
  components: {
    Password: () => import("vue-password-strength-meter"),
  },
  computed: {
    ...mapState({
      username: (state) => state.auth.user,
      user_email: (state) => state.auth.user_email,
    }),
  },
  methods: {
    score(s) {
      this.pwscore = s;
    },
    cancel() {
      if(this.mode === 'details') {
        this.$router.push('/');
      } else {
        this.mode = 'details';
      }
    },
    save() {
      if(this.mode === 'details') {
        // save
      } else {
        // changepw
      }
    },
    updateMyPassword() {
      this.mode = 'changepw';
    },
    resetPassword() {
      this.errpwd = false;
      if (
        this.pwscore < 3 ||
        this.new_pass == "" ||
        this.new_pass_confirm == "" ||
        this.new_pass != this.new_pass_confirm
      ) {
        this.errpwd = true;
        return;
      }
      request
        .post("/user/setpassword", {
          username: this.username,
          password: this.new_pass_confirm,
        })
        .then((resp) => {
          if(resp.data.length === 0) {
            this.snackBarText = 'Password changed successfully';
            this.snackBarStatus = 'success';
            this.snackbar = true;
          } else {
            this.snackBarText = resp.data.error;
            this.snackBarStatus = 'error';
            this.snackbar = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    validEmail: function (email) {
      var re = /^(([^<>()[]\\.,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  }
};
</script>

<style lang="scss" scoped>

::v-deep .Password {
  max-width: 100%;

  &__strength-meter{
    width: calc(100%);
    margin: 8px 0 4px 0;
  }
}

button.apio-button {
  @media (max-width: 1024px) {
    width: 320px;
  }
}

button.apio-button:nth-child(1) {
  margin-right: 8px;

  @media (max-width: 1024px) {
    margin-top: 16px;
  }
}

.my-details__main-col:nth-child(2) {
  display: flex;
  align-items: flex-end;
  margin-bottom: 12px;
}

.my-details {
  margin: 16px 32px 0 32px;

  @media (max-width: 1024px) {
    margin: 12px 20px 0 20px;
  }

  &__weak-strong {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  &__banner {
    background-image: url("/img/misc/apio-colour-header-wide.png");

    @media (max-width: 360px) {
      background-image: url("/img/misc/apio-colour-header-narrow.png");
    }

    background-size: cover;
    padding: 26px 24px;
    color: #fff;
    font-weight: var(--font-semi-bold);
    &--welcome-text {
      font-size: var(--font-h1-size);
    }
    &--strap-line-text {
      font-size: var(--font-h3-size);
    }
  }

  &__main-col {
    padding: 8px;
  }

  &__update-password-link {
    display: flex;
    align-items: center;
  }

  &__password-meter {
    width: calc(100%);
  }

  &__actions {
    margin-top: 32px;
    display: flex;
    @media (max-width: 1024px) {
      flex-direction: column-reverse;
      width: 100%;
    }

    &--buttons {
       @media (max-width: 1024px) {
         max-width: 320px;
         width: 320px;
       }
    }
    &--buttons:first-of-type {
      margin-right: 16px;
    }
  }

  &__main {
    margin-top: 32px;
    padding: 24px;

    @media (max-width: 1024px) {
      margin-top: 16px;
      padding: 16px;
    }
  }
}
</style>
